import storage from 'redux-persist/lib/storage';
import { createFilter } from 'redux-persist-transform-filter';
import config from 'config';

const transforms = [
  createFilter('auth', [
    'userInfo',
    'lockdown',
    'organizations.selectedOrganizationToken',
    'organizations.selectedOrganizationPatientLoginMethod',
    'organizations.selectedOrganizationHasTermsAndConditions',
    'organizations.reCaptchaSiteKey',
    'organizations.siteLogo',
    'organizations.siteLogoLabels',
    'organizations.organizationToken',
    'organizations.organizationLogo',
    'organizations.organizationLogoLabels',
    'organizations.organizationStoreLink',
    'login.status',
  ]),

  createFilter('conference', [
    'consultationInfo.active',
    'consultationInfo.outputSoundLevel',
    'consultationInfo.prevOutputSoundLevel',
    'consultationInfo.switchedLayout',
    'consultationInfo.selfAudioOff',
    'consultationInfo.selfVideoOff',
    'consultationInfo.videoInputs',
    'consultationInfo.audioInputs',
    'remoteMedia.audioDisabled',
    'remoteMedia.videoDisabled',
    // TODO: DeviceId should be always in storage
    'consultationParams.deviceId',
    'consultationLifecycle.reconnection',
    'consultationLifecycle.reconnectionTime',
    'consultationLifecycle.consultationEstablishedAtLeastOneTime',
    // TODO: Instance Id should be wiped when logout
    'consultationParams.instanceId',
    'consultationParams.channel',
    // 'consultationParams.consultationId',
    'consultationStats',
  ]),

  createFilter('session', [
    'refreshToken',
    'sessionInfo.sessionId',
  ]),
];


export const queuesCommonPersisConfig = {
  key: `queues_common-${ config.release_version }`,
  storage,
  debug: true,
  transforms: [
    createFilter('appointmentInfo', [
      'isAppointmentInfoShown',
      'appointmentId',
    ]),
  ],
  whitelist: ['appointmentInfo'],
};

export default {
  key: `web-patient-portal-primary-${ config.release_version }`,
  storage,
  whitelist: [
    'auth',
    'conference',
    'session',
  ],
  transforms,
};
